export const getHomeSiderMainSelectedKey = (path = "") => {
  if (path.startsWith("/admin") || path.startsWith("/settings") || path === "/wiki/settings") {
    return "";
  }
  if (path === "/" || path === "/home" || path === "/home/") {
    return "dashboard";
  }
  if (path.includes("/project-management")) return "projects";
  if (path === "/ai-tools" || path.includes("/chatbot")) return "ai-tools";
  if (path === "/knowledgebase") return "knowledgebase";
  if (path === "/analytics") return "analytics";
  if (path === "/timesheet") return "timesheet";
  if (path.includes("/tasks")) return "tasks";
  if (path.startsWith("/surveys")) return "surveys";
  if (path.includes("/wiki")) return "wiki";
  if (path === "/finances") return "finances";
  if (path === "/newsfeed") return "newsfeed";
  if (path === "/announcements") return "announcements";
  if (path === "/notification" || path === "/notifications") return "notifications";
  if (path === "/training") return "trainings";
  if (path.startsWith("/course/")) return "trainings";
  if (path === "/company-directory/about") return "company-directory-about";
  if (path === "/company-directory/office") return "company-directory-office";
  if (path === "/company-directory/team") return "company-directory-team";
  if (path === "/company-directory/department") return "company-directory-department";
  if (path === "/company-directory/organization") return "company-directory-organization";
  if (path.startsWith("/company-directory")) return "company-directory";

  return "dashboard";
};

export const getHomeSiderMenuMode = (isMobileSidebar) =>
  isMobileSidebar ? "inline" : "vertical";

export const getHomeSiderRouteOpenKeys = ({
  path = "",
  collapsed = false,
  isMobileSidebar = false
} = {}) => {
  if (collapsed || !isMobileSidebar) return [];
  if (path.startsWith("/finances")) return ["finances"];
  if (
    path.startsWith("/knowledgebase") ||
    path.startsWith("/training") ||
    path.startsWith("/course/")
  ) {
    return ["knowledge-learning"];
  }
  if (path.startsWith("/company-directory")) return ["company-directory"];
  if (path.startsWith("/admin") || path.startsWith("/settings") || path === "/wiki/settings") {
    return ["admin"];
  }
  return [];
};

const isAdminOpenKey = (key = "") =>
  key === "admin" ||
  key.startsWith("admin-group-") ||
  key === "hr" ||
  key === "email-settings";

export const getHomeSiderMainMenuSelectedKeys = ({
  mainSelectedKey = "",
  adminSelectedKey = "",
  isMobileSidebar = false
} = {}) => {
  if (isMobileSidebar) {
    return [mainSelectedKey, adminSelectedKey].filter(Boolean);
  }

  return mainSelectedKey ? [mainSelectedKey] : [];
};

export const getHomeSiderMainMenuOpenKeys = (openKeys = [], isMobileSidebar = false) => {
  if (isMobileSidebar) {
    return openKeys;
  }

  return openKeys.filter((key) => !isAdminOpenKey(key));
};

export const getHomeSiderAdminMenuOpenKeys = (openKeys = []) => {
  const adminOpenKeys = openKeys.filter(isAdminOpenKey);
  return adminOpenKeys.includes("admin") ? adminOpenKeys : [];
};

export const getHomeSiderAdminSelectedKey = (
  path = "",
  search = "",
  { useDepartmentRateCard = false } = {}
) => {
  if (path === "/admin/hr/appraisals") return "hr-appraisals";
  if (path === "/admin/hr/surveys") return "hr-surveys";
  if (path === "/admin/hr/leaves") return "hr-leaves";
  if (path === "/admin/hr/recruitment") return "hr-recruitment";
  if (path === "/admin/hr/asset") return "hr-asset";
  if (path === "/admin/hr/trainings") return "hr-trainings";
  if (path === "/admin/hr/flexible-work") return "hr-flexible-work";
  if (path === "/admin/hr/working-location") return "hr-working-location";
  if (path.startsWith("/admin/hr")) return "hr";
  if (path === "/admin/finances") return "admin-finances";
  if (path === "/admin/qna") return "admin-qna";
  if (path === "/admin/user-impersonator") return "admin-user-impersonator";
  if (path === "/admin/activity-log") return "activity-log";
  if (path === "/admin/api-key-management") return "api-key-management";
  if (path === "/admin/email-management") return "email-management";
  if (path === "/admin/ai-prompts") return "ai-prompt-management";
  if (path === "/admin/api-usage") return "api-usage";
  if (
    path === "/admin/vendor-bill-processing" ||
    path === "/admin/aspire-invoice-allocation" ||
    path === "/admin/tech-platform-vendor-bill-buffer"
  ) {
    return "vendor-bill-processing";
  }
  if (path === "/admin/notifications") return "admin-notifications";
  if (path === "/admin/newsfeed") return "newsfeed-settings";
  if (path === "/admin/announcements") return "announcement-settings";
  if (path === "/admin/knowledgebase") return "knowledgebase-settings";
  if (path === "/admin/manage-account") return "manage-account";
  if (path === "/settings/email/banner") return "email-banner";
  if (path === "/settings/email/signature-template") return "email-signature-template";
  if (path === "/wiki/settings") return "wiki-settings";
  if (path.startsWith("/admin/office")) return "office-settings";
  if (path.startsWith("/admin/department")) {
    return search.includes("tab=roles") && useDepartmentRateCard
      ? "department-rate-card"
      : "department-settings";
  }
  if (path.startsWith("/admin/company")) return "company-settings";
  if (path.startsWith("/admin") || path.startsWith("/settings")) return "admin";
  return "";
};
